module.exports = __webpack_public_path__ + "static/media/background-merge.8fa994d2.png";